// ─── src/hooks/useCommunityCatalysts.ts ───────────────────────────────────────

import { useMutation, useQuery, useQueryClient, keepPreviousData } from "@tanstack/react-query";
import {
  deleteCommunityCatalyst,
  getCommunityCatalystStats,
  getCommunityCatalysts,
} from "../api/communityCatalysts";
import type { CommunityCatalystParams } from "../types/communityCatalyst";

export const communityCatalystKeys = {
  all:   ["communityCatalysts"] as const,
  list:  (params: CommunityCatalystParams) =>
    [...communityCatalystKeys.all, "list", params] as const,
  stats: () => [...communityCatalystKeys.all, "stats"] as const,
};

export const useCommunityCatalysts = (params: CommunityCatalystParams) =>
  useQuery({
    queryKey:        communityCatalystKeys.list(params),
    queryFn:         () => getCommunityCatalysts(params),
    placeholderData: keepPreviousData,
    staleTime:       30_000,
  });

export const useCommunityCatalystStats = () =>
  useQuery({
    queryKey:  communityCatalystKeys.stats(),
    queryFn:   getCommunityCatalystStats,
    staleTime: 60_000,
  });

export const useDeleteCommunityCatalyst = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => deleteCommunityCatalyst(id),
    onSuccess:  () => qc.invalidateQueries({ queryKey: communityCatalystKeys.all }),
  });
};
